<form #filterForm="ngForm">
  <div class="flex flex-wrap justify-start lg:justify-end gap-4">

    <!-- Form State -->
    <div class="flex flex-col w-full sm:w-auto">
      <select
        name="formState"
        [(ngModel)]="selectedFormState"
        (change)="onSearch(filterForm)"
        class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1.5 placeholder-gray-400 w-full sm:w-auto"
      >
        <option [ngValue]="undefined">Select form state</option>
        <option *ngFor="let type of formStates" [ngValue]="type">
          {{ type }}
        </option>
      </select>
    </div>

    <!-- Date range picker -->
    <div class="flex flex-col w-full sm:w-auto">
      <p-datepicker
        name="rangeDates"
        [(ngModel)]="rangeDates"
        selectionMode="range"
        clearButtonStyleClass="bg-red right-4 ml-6 text-red"
        [inputStyle]="{
          border: 'none',
          paddingLeft: '0',
          paddingRight: '0',
          paddingTop:'0'
        }"
        [styleClass]="
          'peer block px-0 pr-10 w-full text-sm text-gray-900 appearance-none border-0 border-b-2 focus:outline-none focus:ring-0 border-gray-300 focus:border-[#1f273b]'
        "
        (onSelect)="onDateChange()"
        (onClear)="onDateChange()"
        placeholder="Search by date"
        showClear="true"
      ></p-datepicker>
    </div>

      <!-- Filing Id + validation -->
<div class="flex flex-col w-full sm:w-auto">
  <input
    type="text"
    name="filingId"
    placeholder="Search by filing Id"
    [(ngModel)]="filingIdInput"
    #filingIdCtrl="ngModel"
    pattern="^[0-9]*$"

    (keydown)="preventSpaceKey($event)"
    (keydown.enter)="onSearch(filterForm)"
    (paste)="onPaste($event, 'filingIdInput')"

    class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529]
           px-1 py-1.5 placeholder-gray-400 w-full sm:w-auto"
  />

  <small
    class="text-red-600 mt-1"
    *ngIf="filingIdCtrl.invalid && (filingIdCtrl.dirty || filingIdCtrl.touched)"
  >
    Filing ID must be an integer.
  </small>
</div>

    <!-- Issuer Name + validation -->
    <div class="flex flex-col w-full sm:w-auto">
      <input
        type="text"
        name="issuerName"
        placeholder="Search by issuer name"
        [(ngModel)]="issuerNameInput"
        #issuerNameCtrl="ngModel"
        (keydown)="preventSpaceKey($event)"
        (paste)="onPaste($event, 'issuerNameInput')"
        (keydown.enter)="onSearch(filterForm)"
        class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1.5 placeholder-gray-400 w-full sm:w-auto"
      />
    </div>

    <!-- Form Type -->
    <div class="flex flex-col w-full sm:w-auto">
      <select
        name="formType"
        [(ngModel)]="selectedFormType"
        (change)="onSearch(filterForm)"
        class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1.5 placeholder-gray-400 w-full sm:w-auto"
      >
        <option [ngValue]="undefined">Select form type</option>
        <option *ngFor="let type of formTypes" [ngValue]="type">
          {{ type }}
        </option>
      </select>
    </div>

    <!-- Analyst Filter -->
    <div class="flex flex-col w-full sm:w-auto">
      <select
        name="selectedByAnalyst"
        [(ngModel)]="selectedByAnalyst"
        (change)="onSearch(filterForm)"
        class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1.5 placeholder-gray-400 w-full sm:w-auto"
      >
        <option [ngValue]="undefined">Select analyst</option>
        <option *ngFor="let user of usersList" [ngValue]="user">
          {{ user }}
        </option>
      </select>
    </div>

  </div>
</form>

<div class="mb-4"></div>
<p-table
  [value]="filings"
  [paginator]="filings.length > 0"
  [first]="first"
  (onLazyLoad)="loadData($event)"
  [lazy]="true"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [loading]="isLoading"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  [rowsPerPageOptions]="[10, 25, 50]"
>
  <ng-template pTemplate="header">
    <tr>
      <th>Filing ID</th>
      <th>Form Type</th>
      <th>Accession Number</th>
      <th>Issuer Name</th>
      <th>Source URL</th>
      <th>Locked</th>

      <th>Trading Plan Count</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-filing>
    <tr>
      <td>
        <a
          href="#"
          (click)="openViewModal(filing.filingId, $event)"
          style="color: #4a90e2; text-decoration: underline; cursor: pointer"
          >{{ filing.filingId }}</a
        >
      </td>
      <td>{{ filing.formType }}</td>
      <td>{{ filing.accessionNumber }}</td>
      <td>{{ filing.issuerName }}</td>
      <td>
        <a
          href="{{ filing.sourceUrl }}"
          *ngIf="filing.sourceUrl"
          target="_blank"
          >Link</a
        >

        <span *ngIf="!filing.sourceUrl">-</span>
      </td>
      <td>{{ filing.locked }}</td>

      <td>{{ filing.tradingPlanCount }}</td>
    </tr>
  </ng-template>
</p-table>
<ng-container *ngIf="!isLoading && filings.length === 0">
  <div class="text-center py-6 text-gray-500">No record found</div>
</ng-container>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
